"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FacilitiesModalComponent;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _nextI18next = require("next-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FacilitiesModalComponent(_ref) {
  var {
    facilities,
    isModalVisible,
    onModalClose
  } = _ref;
  var {
    t
  } = (0, _nextI18next.useTranslation)(['common']);
  return (0, _jsxRuntime.jsx)(_atoms.ModalVariants, {
    isOpen: isModalVisible,
    onClose: onModalClose,
    dataTestId: "facilities-modal",
    variant: "info",
    variantProps: {
      title: t('facilities.modal.title'),
      delimiter: true
    },
    children: (0, _jsxRuntime.jsx)(_react.VStack, _objectSpread(_objectSpread({}, modalStyles), {}, {
      children: (0, _jsxRuntime.jsx)(_atoms.List, _objectSpread(_objectSpread({
        "data-testid": "facilities-list"
      }, listStyles), {}, {
        children: facilities === null || facilities === void 0 ? void 0 : facilities.map(facility => (0, _jsxRuntime.jsxs)(_react.HStack, {
          spacing: "1.5rem",
          children: [(0, _jsxRuntime.jsx)(_atoms.Icon, {
            src: (0, _utils.formatAssetsUrl)(facility === null || facility === void 0 ? void 0 : facility.icon),
            w: "6"
          }), facility !== null && facility !== void 0 && facility.description ? (0, _jsxRuntime.jsxs)(_atoms.List, {
            gap: "1",
            children: [(0, _jsxRuntime.jsx)(_react.Text, {
              "data-testid": "facility-title",
              children: facility === null || facility === void 0 ? void 0 : facility.name
            }), (0, _jsxRuntime.jsx)(_react.Text, {
              "data-testid": "facility-description",
              color: "darkGrey2",
              children: facility === null || facility === void 0 ? void 0 : facility.description
            })]
          }) : (0, _jsxRuntime.jsx)(_react.Text, {
            "data-testid": "facility-title",
            children: facility === null || facility === void 0 ? void 0 : facility.name
          })]
        }, facility === null || facility === void 0 ? void 0 : facility.code))
      }))
    }))
  });
}
var modalStyles = {
  w: {
    base: 'calc(100vw - var(--chakra-space-3xl))',
    md: '30.375rem',
    xl: '36.875rem'
  },
  px: 6,
  py: '2xl'
};
var listStyles = {
  w: 'full',
  fontWeight: 500,
  gap: 10
};